export default class PostTypes {
  postComponents = {};

  /**
   * Register a new post component type.
   * Usually used for event posts.
   *
   * @param name The name of the post type.
   * @param component The component class to render the post.
   */
  add(name, component) {
    this.postComponents[name] = component;
    return this;
  }
  extend(app, extension) {
    Object.assign(app.postComponents, this.postComponents);
  }
}
flarum.reg.add('core', 'common/extenders/PostTypes', PostTypes);